
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useOrganizationUsers = () => {
  const { currentOrganization, profile } = useAuth();

  return useQuery({
    queryKey: ['organization-users', currentOrganization?.id],
    queryFn: async () => {
      if (!currentOrganization || !profile) return [];

      // Since we simplified the role system, all authenticated users can view organization users
      // In the future, you might want to implement more granular permissions
      const { data, error } = await supabase
        .from('organization_memberships')
        .select(`
          user_id,
          profiles!inner(
            id,
            email,
            first_name,
            last_name,
            role,
            created_at
          )
        `)
        .eq('organization_id', currentOrganization.id)
        .eq('status', 'accepted');

      if (error) throw error;
      return data?.map(membership => membership.profiles).filter(Boolean) || [];
    },
    enabled: !!currentOrganization && !!profile,
  });
};
